import { ATTENDANCE_MODES } from 'shared/constants/schedule.constants';
import { Modal, Button } from 'src/components/design-system';
import { useEducationalEventsContext } from '../../educational-events-context';
import styles from './check-in.module.scss';

export function AttendanceModePromptModal({ open, onPick, onCancel }) {
  const { lang } = useEducationalEventsContext();

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={lang.HOW_ARE_YOU_ATTENDING}
      footer={null}
      width={360}>
      <div className={styles.attendModeActions}>
        <Button block type="primary" onClick={() => onPick(ATTENDANCE_MODES.IN_PERSON)}>
          {lang.FORMAT_IN_PERSON}
        </Button>
        <Button block onClick={() => onPick(ATTENDANCE_MODES.VIRTUAL)}>
          {lang.FORMAT_VIRTUAL}
        </Button>
      </div>
    </Modal>
  );
}
